import React, { useState, useEffect, useCallback } from 'react';
import {
    GoogleReCaptchaProvider,
    GoogleReCaptcha,
    useGoogleReCaptcha
} from 'react-google-recaptcha-v3';
import axios from "axios";

function Recaptcha() {

    const verifyCallback = (recaptchaToken) => {
            // Here you will get the final recaptchaToken!!!
            console.log(recaptchaToken);
            // ここで取得したキーをもとに認証を通すことをする
            
            axios.get(`https://jsonplaceholder.typicode.com/users`)
            .then(res => {

            console.log(res);
            })
        }

    return (
        <div>
            <GoogleReCaptcha
                reCaptchaKey="6LfAiqIdAAAAAKjQLm8ILPX-t6ld8mAOXGM-FuaH"
                onVerify={verifyCallback} />
        </div>
    );
};


export default Recaptcha;
